module.exports = __webpack_public_path__ + "img/order-process-image-01.2c269ee.svg";